import { Observable } from "rxjs";
import { inject, Injectable } from "@angular/core";
import { CommonService } from "@sportyano/core/services/shard/common.service";
import { environment } from "src/environments/environment";
import { PlaygroundResponse } from "@sportyano/core/models/playground-card/playground-card.model";
import { SinglePlaygroundResponse } from "@sportyano/core/models/single-playground-details/single-playground.model";
import {
	ITimeSlotRequest,
	TimeSlotResponse,
} from "@sportyano/core/models/programs/time-slots.model";
import { HttpClient } from "@angular/common/http";
import { IPlaygroundReservedResponse } from "@sportyano/shared/components/custom-calendar/models/const/reserved-response";
import { IPlaygroundDetailsResponse } from "@sportyano/core/models/playgrounds/playground.interface";
import { IUpdatePlayground } from "@sportyano/account/components/playground/models/playground.interface";
import { ITopGroundsResponse } from "@sportyano/core/models/ibooking-ground";

@Injectable({
	providedIn: "root",
})
export class PlaygroundService {
	private _http = inject(HttpClient);
	constructor(private commonServices: CommonService) {}

	getPlaygrounds(params: any): Observable<PlaygroundResponse> {
		return this.commonServices.CommonGetWithParamRequests(
			`${environment.baseUrl}home-page/playgrounds`,
			params
		);
	}

	public getSelectedPlaygrounds() {
		return this.commonServices.CommonGetRequests(
			`${environment.baseUrl}home-page/main-page-playgrounds`
		);
	}

	getSinglePlayground(id: string): Observable<SinglePlaygroundResponse> {
		return this.commonServices.CommonGetRequests(
			`${environment.baseUrl}home-page/playgrounds/${id}`
		);
	}

	public updatePlaygroundSchedule(
		playgroundId: string,
		slots: Array<ITimeSlotRequest>
	) {
		const url = `${environment.baseUrl}playgrounds/${playgroundId}/time-slots`;
		return this._http.post(url, { slots: slots });
	}

	public bulkUpdatePlaygroundSchedule(
		playgroundId: string,
		payload: {
			start_date: string;
			end_date: string;
			status: boolean | number;
			days?: string[];
			hours?: string[];
			from_time?: string;
			to_time?: string;
		}
	): Observable<any> {
		const url = `${environment.baseUrl}playgrounds/${playgroundId}/time-slots/bulk-schedule`;
		return this._http.post(url, payload);
	}

	public getReservedPlayground(
		playgroundId: string
	): Observable<TimeSlotResponse> {
		const url = `${environment.baseUrl}playgrounds/${playgroundId}/time-slots`;
		return this._http.get<TimeSlotResponse>(url);
	}

	public getReservedPlaygroundDates(
		programId: string,
		startDate: string,
		endDate: string
	): Observable<Array<IPlaygroundReservedResponse>> {
		const url = `${environment.baseUrl}get/booking/list/playground/${programId}?startDate=${startDate}&endDate=${endDate}`;
		return this._http.get<Array<IPlaygroundReservedResponse>>(url);
	}

	public getPlaygroundDetails(
		id: string
	): Observable<IPlaygroundDetailsResponse> {
		const url = `${environment.baseUrl}playgrounds/grounds/${id}`;
		return this._http.get<IPlaygroundDetailsResponse>(url);
	}
	public getPlaygroundPendingDetails(
		id: string
	): Observable<any> {
		const url = `${environment.baseUrl}pending-grounds/${id}`;
		return this._http.get<any>(url);
	}
	public updatePlayground(payload: IUpdatePlayground) : Observable<Object>{
		const url = `${environment.baseUrl}playgrounds/grounds/${payload.id}`;
		return this._http.put(url, payload.playground);
	}
	public updatePendingPlayground(payload: IUpdatePlayground) : Observable<Object>{
		const url = `${environment.baseUrl}pending-grounds/${payload.id}`;
		return this._http.put(url, payload.playground);
	}
	public getAdvertisement(page:string,device:string){
		return this._http.get<any>(`${environment.baseUrl}home-page/advertisment?page=${page}&device=${device}`)
	}

	public getTopGrounds(
	): Observable<ITopGroundsResponse> {
		return this.commonServices.CommonGetRequests(
			`${environment.baseUrl}home-page/main-page-grounds`
		);
	}

}
